import APIFile from "./APIFile";
import API from "./API";

export const magicApi = (params) => {
  // debugger;
  // return API.post("/magic/image/match", params, {
  //   headers: {
  //     "Content-Type": "multipart/form-data",
  //   },
  // });
  const fd = new FormData();
  fd.append("files", params?.formData, params?.formData?.name || "roi.jpg");
  if (params?.mobileFlag) {
    return APIFile.post(
      `/ecommerce/magic/image/match`,
      fd,
    )
      .then((response) => {
        return response;
      })
      .catch((error) => {
        throw error;
      });
  } else {
    return APIFile.post(`/ecommerce/magic/image/match`, fd, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    })
      .then((response) => {
        return response;
      })
      .catch((error) => {
        throw error;
      });
  }
};


export const getQrCodeApi = async (payload) => {
  try {
    const response = await API.get(
      `/ecommerce/magic/image/qr?customerCode=${payload?.customerCode}`,
    );
    return response;
  } catch (error) {
    throw error;
  }
};